export const LETTERS_WITH_DESCENDERS = ['g', 'j', 'p', 'q', 'y'];
